import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface ChoosePaymentPluginVariables {
  paymentPluginId?: string
  order_id?: GQL_ID
  source?: string
  clientSettings?: {
    backLink?: string
  }
}

interface ChoosePaymentPluginResponse {
  choosePaymentPlugin: {
    pluginId: string
    type: string
    payload: {
      embed?: string | null
      controllable?: string | null
      redirect?: string | null
    }
    operationId: string
  }
}

export const GQL_MUTATION_CHOOSE_PAYMENT_PLUGIN = gql`
  mutation choosePaymentPlugin($order_id: ID, $paymentPluginId: String, $source: String, $clientSettings: PaymentPluginClientSettings) {
    choosePaymentPlugin(order_id: $order_id, pluginId: $paymentPluginId, source: $source, clientSettings: $clientSettings) {
      pluginId
      type
      payload {
        embed
        controllable
        redirect
      }
      operationId
    }
  }
`

export const useMutateChoosePaymentPlugin = () =>
  useMutation<ChoosePaymentPluginResponse, ChoosePaymentPluginVariables>(
    GQL_MUTATION_CHOOSE_PAYMENT_PLUGIN,
  )
